var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    focusable: "false",
    "aria-hidden": "true",
    className: "a8x1wuu _1fragemop _1fragempq _1fragemlt _1fragemlo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M6.3 2.1H2.7a.6.6 0 0 0-.6.6v8.6a.6.6 0 0 0 .6.6h8.6a.6.6 0 0 0 .6-.6V7.7m.7-2.8V1.6a.2.2 0 0 0-.2-.2H9.1M7 7l5-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareArrow);
export default __webpack_public_path__ + "static/media/squareArrow.d04af4560b630db2f136344af2ecb183.svg";
export { ForwardRef as ReactComponent };